import { useMemo, memo } from 'react';

import { BATCH_TOOLS } from 'pages/Batch/configs';
import { BatchDataStatus } from 'configs/constants';
import useBatchData from 'pages/Batch/sections/Context/useBatchData';

import RemoveBgTool from './RemoveBgTool';
import CropTool from './CropTool';
import AIEnhanceTool from './AIEnhanceTool';
import WatermarkTool from './WatermarkTool/WatermarkTool';
import ResizeTool from './ResizeTool';
import RemoveBgResizeTool from './RemoveBgResizeTool';

const Sidebar = () => {
  const { selectedData, activeTool } = useBatchData();

  const inProgress = useMemo(
    () => selectedData.some(el => el.status === BatchDataStatus.IN_PROGRESS),
    [selectedData],
  );

  return (
    <>
      {activeTool === BATCH_TOOLS.removeBG && <RemoveBgTool inProgress={inProgress} />}
      {activeTool === BATCH_TOOLS.enhance && <AIEnhanceTool inProgress={inProgress} />}
      {activeTool === BATCH_TOOLS.crop && <CropTool inProgress={inProgress} />}
      {activeTool === BATCH_TOOLS.resize && <ResizeTool />}
      {activeTool === BATCH_TOOLS.watermark && <WatermarkTool />}
      {activeTool === BATCH_TOOLS.removeBG_resize && <RemoveBgResizeTool inProgress={inProgress} />}
    </>
  );
};

export default memo(Sidebar);
